import React from 'react';
import PropTypes from 'prop-types';

import { Navigation, Footer } from './components';

const Layout = ({ children }) => (
  <>
    <Navigation />
    {children}
    <Footer />
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
